import React from 'react';
import TaskColumn from './TaskColumn';

const TasksColumn = ({
  goals,
  selectedGoal,
  selectedStep,
  selectedTask,
  setSelectedTask,
  newTaskText,
  setNewTaskText,
  addTask,
  setGoals,
  columnHeaders,
  setColumnHeaders,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  filterState,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop
}) => {
  const tasks = goals
    .find((g) => g.id === selectedGoal)
    ?.steps.find((s) => s.id === selectedStep)
    ?.tasks || [];

  const toggleTaskCompletion = (taskId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.map((task) =>
                  task.id === taskId ? { ...task, completed: !task.completed } : task
                ),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
  };

  const deleteTask = (taskId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.filter((task) => task.id !== taskId),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    if (selectedTask === taskId) {
      setSelectedTask(null);
    }
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const setTaskPriority = (taskId, priority) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.map((task) =>
                  task.id === taskId ? { ...task, priority: priority } : task
                ),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const updateTaskTitle = (taskId, newTitle) => {
    const updatedGoals = goals.map(g => 
      g.id === selectedGoal ? {
        ...g, 
        steps: g.steps.map(s => 
          s.id === selectedStep ? {
            ...s,
            tasks: s.tasks.map(t =>
              t.id === taskId ? {...t, title: newTitle} : t
            )
          } : s
        )
      } : g
    );
    setGoals(updatedGoals);
    setEditingItemId(null);
  };

  return (
    <TaskColumn
      type="task"
      items={tasks}
      selectedId={selectedTask}
      setSelectedId={setSelectedTask}
      newItemText={newTaskText}
      setNewItemText={setNewTaskText}
      addItem={addTask}
      toggleCompletion={toggleTaskCompletion}
      columnHeaders={columnHeaders}
      setColumnHeaders={setColumnHeaders}
      headerKey="tasks"
      openMenuId={openMenuId}
      setOpenMenuId={setOpenMenuId}
      openSubmenuId={openSubmenuId}
      setOpenSubmenuId={setOpenSubmenuId}
      deleteItem={deleteTask}
      setPriority={setTaskPriority}
      goalId={selectedGoal}
      stepId={selectedStep}
      filterState={filterState}
      editingItemId={editingItemId}
      setEditingItemId={setEditingItemId}
      editingText={editingText}
      setEditingText={setEditingText}
      updateItemTitle={updateTaskTitle}
      draggedItem={draggedItem}
      handleDragStart={handleDragStart}
      handleDragOver={handleDragOver}
      handleDrop={handleDrop}
      isDisabled={!selectedGoal || !selectedStep}
    />
  );
};

export default TasksColumn; 